// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Kk2p","inner":"Footer_inner__RkQqM","nextIcon":"Footer_nextIcon__1ojDH","innerLeft":"Footer_innerLeft__3Sflh"};